import axiosInstance from "./axiosInstance";

const agentAlertSoundService = {
  getCatalog: async () =>
    (await axiosInstance.get("/admin/agent-alert-sounds/catalog")).data,
  getMine: async () =>
    (await axiosInstance.get("/admin/agent-alert-sounds/mine")).data,
  listTeam: async () =>
    (await axiosInstance.get("/admin/agent-alert-sounds")).data,
  setAgentSound: async (agentId, payload) =>
    (
      await axiosInstance.put(`/admin/agent-alert-sounds/${agentId}`, payload)
    ).data,
  uploadCustom: async (file, label) => {
    const form = new FormData();
    form.append("file", file);
    if (label) form.append("label", label);
    return (
      await axiosInstance.post("/admin/agent-alert-sounds/custom", form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).data;
  },
  deleteCustom: async (soundKeyOrId) =>
    (
      await axiosInstance.delete(
        `/admin/agent-alert-sounds/custom/${encodeURIComponent(soundKeyOrId)}`
      )
    ).data,
};

export default agentAlertSoundService;
